module.exports = {
	"articleTitle1": "Pride Night at Necto: We found love in a safer space",
	"catImage": "yellowstar.png",
	"totalCats": 2,
	"name": "Necto Nightclub",
	"articleLink1": "https://www.michigandaily.com/arts/02pride-night-at-necto-we-found-love-at-a-safer-place13",
	"articleLink2": "https://www.michigandaily.com/section/arts/%E2%80%9Cwe%E2%80%99re-all-born-naked-and-rest-drag%E2%80%9D",
	"articleSnippet1": "Feb 12, 2014 ... These pervasive straight spaces are what made the idea of spending a Friday at \nPride Night at Necto nightclub all the more intriguing — and, ...",
	"articleSnippet2": "Jan 16, 2017 ... Necto nightclub on an ordinary Friday night is always a great place to begin the \nweekend with your friends. But this past Friday, January 13th, ...",
	"foodRecommendations": [
		{
			"text": "Every Friday is Pride night!",
			"person": "Erik Forkin"
		},
		{
			"text": "One of the only true clubs in AA",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "The Rest is Drag: 'RuPaul' alum performs at Necto ",
	"address": "516 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/151105/cea.ART_.CashCash740.jpg?itok=X1gChd0e",
			"author": "Claire Abdo",
			"caption": "People mob the dance floor at Necto Night Club Wednesday night for Cash Cash."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/gallery/public/galleryies/del.Arts_.Matoma.4.6.16.326.jpg?itok=1q00036y",
			"author": "Delaney Ryan",
			"caption": "A crowd dances as Matoma, a DJ and record producer of tropical house music, performs at Necto on April 6, 2016."
		}
	],
	"position": {
		"lat": 42.2792,
		"lng": -83.7424
	},
	"totalMisc": 0,
	"categories": {
		"livemusic": 1,
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/necto.json
// module id = 931
// module chunks = 0